import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  shippingOptions: {
    wsp_destination_notification: false,
  },
};

const shippingOptionsSlice = createSlice({
  name: 'shippingOptions',
  initialState,
  reducers: {
    setShippingOption(state, action) {
      const { point, data } = action.payload;
      state.shippingOptions[point] = data;
    },
    clearShippingOptions: (state) => {
      Object.keys(state).forEach((key) => {
        state[key] = initialState[key];
      });
    },
  },
});

export const { setShippingOption, clearShippingOptions } = shippingOptionsSlice.actions;
const shippingOptionsReducer = shippingOptionsSlice.reducer;

export default shippingOptionsReducer;
